import { Button } from './button';

type ErrorAlertProps = {
  title?: string;
  message?: string;
  action?: () => void;
};

export function ErrorAlert({ message, title, action }: ErrorAlertProps) {
  return (
    <div className="flex flex-1 items-center justify-center p-4">
      <div
        className="relative flex max-h-full max-w-screen-md flex-col gap-4 overflow-auto rounded border border-destructive bg-destructive px-4 py-3 text-destructive-foreground"
        role="alert"
      >
        {title && <span className="text-center font-bold">{title}</span>}
        {message && <pre className="whitespace-break-spaces">{message}</pre>}
        {action && (
          <div className="flex items-center justify-center">
            <Button type="button" variant="outline" onClick={action}>
              Riprova
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
